/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { withWidth } from '@material-ui/core';
import { devConfig } from '../../../common/Config';
import AjaxHelper from '../../../common/AjaxHelper';

function HeaderLogo(props) {
	const [url, setUrl] = useState('/');
	const { customAttributes, otherSettings, width } = props;
	const { logo } = customAttributes || {};
	if (logo && logo === 'none') return null;
	const { logo_height, logo_width } = (otherSettings && otherSettings.logo) || {};
	const logoHeight = width === 'xs' ? (logo_height * 0.75 || '44px') : (logo_height || '60px');
	const logoWidth = logo_width || 'auto';
	const styleLogo = { width: logoWidth, height: logoHeight, maxHeight: 'none' };
	useEffect(() => {
		let isMounted = true;
		(async () => {
			const config = await AjaxHelper.invokeServerAPIPromise('/api/config', {
				websiteURL: 1
			});
			if (config.websiteURL && window.location.pathname === '/' && isMounted) setUrl(config.websiteURL);
		})();
		return () => { isMounted = false; };
	}, []);
	return (
		<a href={url}>
			<img
				className="desktop-img desktop-header-logo"
				src={`${devConfig.serverURI}/images/logo/logo_white.png`}
				alt="img of logo"
				style={styleLogo}
			/>
		</a>
	);
}

export default withWidth()(HeaderLogo);
